import { AfterViewInit, Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { Role } from '../models/role.model';
import { DagreNodesOnlyLayout, Edge, GraphComponent, Layout, Node as NgxNode } from '@swimlane/ngx-graph';
import * as shape from 'd3-shape';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-career-path',
  templateUrl: './career-path.component.html',
  styleUrls: ['./career-path.component.css']
})
export class CareerPathComponent implements OnInit, AfterViewInit {

  @Input() data: Role[];
  @Input() practiceId: number;
  @Input() departmentId: number;
  @Input() isMyCareer: boolean;
  @Input() practiceName: string;
  @Input() departmentName: string;
  firstNode: NgxNode;
  public nodes: NgxNode[] = [];
  public links: Edge[] = [];
  public layoutSettings = {
    orientation: 'TB'
  };
  public curve: any = shape.curveLinear;
  public layout: Layout = new DagreNodesOnlyLayout();
  public panOffsetX: number = 0;
  public panOffsetY: number = 0;
  showGraph: boolean = false;

  gradeCount: number;

  panToNode$: Subject<string> = new Subject();

  @ViewChild('graphdiv') graph: ElementRef;

  constructor() { }

  ngOnInit(): void {
    if (this.data) {
      let visted: any = {};
      for (const role of this.data) {
        this.gradeCount = 0;
        var roleData = Array.from(role.levels);
        roleData.forEach(element => {
          this.gradeCount += element.grades.length
        });
        const node: NgxNode = {
          id: role.departmentRoleId.toString(),
          data: role,
          label: role.roleName,
          dimension: {
            // width: 210 + (role.roleName.length * 3),
            width: 350,
            height: this.gradeCount * 85
          }
        };
        if (!visted[node.id]) {
          this.nodes.push(node);
          visted[node.id] = "visited";
        }
        if (role.departmentSuccessorRoleId) {
          this.links.push({ source: node.id, target: role.departmentSuccessorRoleId.toString() })
        }
      }
      this.firstNode = this.nodes.find((x) => { this.links.every((y) => y.target != x.id) });
      this.showGraph = true;
    }
  }

  ngAfterViewInit() {
    if (this.firstNode) {
      this.panToNode$.next(this.firstNode.id);
    }
  }

  scrollUp() {
    this.graph.nativeElement.scrollTop -= 150;
  }

  scrollDown() {
    this.graph.nativeElement.scrollTop += 150;
  }
}
